export const dataByTypename = (data) =>
  data && data.__typename ? { [data.__typename]: data } : {}
